import { EmployeeSchema, EmployeeSummarySchema, paginatedResponseSchema } from '@gestion-permisos/contracts';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/api-context.js';
import { MY_REQUESTS_PAGE_SIZE } from '../requests/requests-api.js';

const TeamPageSchema = paginatedResponseSchema(EmployeeSummarySchema);

/** Una página del equipo directo (`GET /me/team`), del mismo tamaño que los listados de solicitudes. */
export function useMyTeamPage(page: number) {
  const api = useApi();
  return useQuery({
    queryKey: ['team', 'members', page],
    queryFn: () => api.get(`/api/v1/me/team?page=${page}&pageSize=${MY_REQUESTS_PAGE_SIZE}`, TeamPageSchema),
  });
}

/**
 * Ficha de un subordinado (`GET /employees/{id}`). El ámbito lo decide la API: si ya no es subordinado
 * directo responde 404. La pantalla no muestra `entraObjectId`, `upn`, `areaId` ni `managerId`.
 */
export function useEmployee(id: string) {
  const api = useApi();
  return useQuery({
    queryKey: ['team', 'employee', id],
    queryFn: () => api.get(`/api/v1/employees/${encodeURIComponent(id)}`, EmployeeSchema),
  });
}
